// extracted by css-extract-rspack-plugin
export default {"breadcrumbs":"breadcrumbs-2FKjT","breadcrumb":"breadcrumb-291KA"};